import {
  Skeleton,
  Container,
  Box,
  AppBar,
  Toolbar,
  Typography,
} from "@mui/material";

const ProductSkeleton = () => {
  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        backgroundColor: "#F6F6F6",
        minHeight: "100vh",
        pb: 0,
        mb: 0,
        width: "100%",
      }}
    >
      <Box width="100%">
        {/* Top Navigation Skeleton */}
        <Box sx={{ backgroundColor: "#F6F6F6" }}>
          <AppBar
            position="static"
            color="transparent"
            elevation={0}
            sx={{ pl: 2, pt: 1, pb: 2 }}
          >
            <Toolbar>
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" width={100} height={40} sx={{ ml: 2 }} />
            </Toolbar>
          </AppBar>

          {/* Product Image Skeleton */}
          <Box textAlign="center">
            <Skeleton
              variant="rectangular"
              width="80%"
              height="15vh"
              sx={{ borderRadius: 8, margin: "0 auto" }}
            />
          </Box>

          {/* Product Details Skeleton */}
          <Box
            sx={{
              mt: -5,
              backgroundColor: "white",
              borderRadius: "40px 40px 0 0",
              width: "100%",
              padding: 3,
              pt: 5,
              boxShadow: "0px -5px 20px rgba(0,0,0,0.1)",
              minHeight: "95vh",
            }}
          >
            {/* Product Name */}
            <Skeleton variant="text" width="70%" height={40} sx={{ mb: 2 }} />

            {/* Rating and Cart Skeleton */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Skeleton variant="rectangular" width="40%" height={30} />
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                sx={{ mr: 1 }}
              />
            </Box>

            {/* Classification Chips Skeleton */}
            <Box mt={1}>
              <Skeleton
                variant="rounded"
                width="20%"
                height={30}
                sx={{ mr: 1 }}
              />
              <Skeleton variant="rounded" width="15%" height={30} />
            </Box>

            {/* Description Section */}
            <Box mt={2}>
              <Skeleton variant="text" width="40%" height={30} />
              <Skeleton variant="text" width="100%" />
              <Skeleton variant="text" width="90%" />
              <Skeleton variant="text" width="80%" />
            </Box>

            {/* Ingredients Section */}
            <Box sx={{ mt: 2 }}>
              <Skeleton variant="text" width="30%" height={30} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                sx={{ mt: 1 }}
              />
            </Box>

            {/* Similar Products Skeleton */}
            {/* <Box sx={{ mt: 2, display: "flex", overflowX: "auto" }}>
              {[...Array(4)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width="17vh"
                  height="30vh"
                  sx={{ mr: 2, flexShrink: 0 }}
                />
              ))}
            </Box> */}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ProductSkeleton;
